import React, { useEffect, Fragment } from 'react';

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withNamespaces } from 'react-i18next';

const SidebarContent = (props) => {

    // Use ComponentDidMount and ComponentDidUpdate method symultaniously

    useEffect(() => {

        var pathName = props.location.pathname;

        const initMenu = () => {
            new MetisMenu("#side-menu");
            var matchingMenuItem = null;
            var ul = document.getElementById("side-menu");
            var items = ul.getElementsByTagName("a");
            for (var i = 0; i < items.length; ++i) {
                if (pathName === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        }
        initMenu();
    }, [props.location.pathname]);


    function activateParentDropdown(item) {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;
                    if (parent4) {
                        parent4.classList.add("mm-active");
                    }
                }
            }
            return false;
        }
        return false;
    };

    const role = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")).data.role : ""
    return (
        <React.Fragment>
            <div id="sidebar-menu">
                <ul className="metismenu list-unstyled" id="side-menu">
                    <Fragment>
                        {role !== "admin" && (
                            <React.Fragment>
                                <li>
                                    <Link to="/dashboard" className="waves-effect">
                                        <i className="bx bxs-widget" aria-hidden="true"></i>
                                        <span>{props.t('Dashboard')}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/screens" className="waves-effect">
                                        <i className="mdi mdi-monitor" aria-hidden="true"></i>
                                        <span>{props.t('Screens')}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contents" className="waves-effect">
                                        <i className="mdi mdi-calendar-edit" aria-hidden="true"></i>
                                        <span>{props.t('Content')}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/campaigns" className="waves-effect">
                                        <i className="mdi mdi-bullhorn-outline" aria-hidden="true"></i>
                                        <span>{props.t('Campaigns')}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/report" className="waves-effect">
                                        <i className="mdi mdi-folder-open-outline" aria-hidden="true"></i>
                                        <span>{props.t('Report')}</span>
                                    </Link>
                                </li>
                            </React.Fragment>
                            )}
                        {role === "admin" && (
                            <li>
                                <Link to="/manage_users" className="waves-effect">
                                    <i className="mdi mdi-account-cog" aria-hidden="true"></i>
                                    <span>{props.t('Users')}</span>
                                </Link>
                            </li>
                        )}
                        <li>
                            <Link to="/settings" className="waves-effect">
                                <i className="mdi mdi-cog-outline" aria-hidden="true"></i>
                                <span>{props.t('Settings')}</span>
                            </Link>
                        </li>
                    </Fragment>
                </ul>
            </div>
        </React.Fragment>
    );
}

export default withRouter(withNamespaces()(SidebarContent));


